import { createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const legalEntitiesHierarchyFeatureKey = 'legalEntitiesHierarchy';

export interface LegalEntitiesHierarchyState {
  loadLegalEntitiesHierarchy: any;
  loadLegalEntitiesHierarchyResponse: any;
  loadLegalEntitiesHierarchyFailure: any;
  loaded: boolean;
  saveLegalEntityId: string;
}

export const initialState: LegalEntitiesHierarchyState = {
  loadLegalEntitiesHierarchy: undefined,
  loadLegalEntitiesHierarchyResponse: undefined,
  loadLegalEntitiesHierarchyFailure: undefined,
  loaded: false,
  saveLegalEntityId: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadLegalEntitiesHierarchy, (state, action) => ({
    ...state,
    loadLegalEntitiesHierarchy: action.request
  })),
  on(actions.loadLegalEntitiesHierarchySuccess, (state, action) => ({
    ...state,
    loadLegalEntitiesHierarchyResponse: action.response,
    loaded: true
  })),

  on(actions.clearLegalEntitiesHierarchy, (state, action) => ({
    ...state,
    loadLegalEntitiesHierarchyResponse: undefined,
    loaded: false
  })),

  on(actions.saveSelectedLegalEntitiyId, (state, action) => ({
    ...state,
    saveLegalEntityId: action.save
  })),
  on(actions.loadLegalEntitiesHierarchyFailure, (state, action) => ({
    ...state,
    loadLegalEntitiesHierarchyFailure: action.error,
    loaded: false
  })),
  on(actions.clearLegalEntitiySelected, (state, action) => ({
    ...state,
    saveLegalEntityId: undefined,
    loaded: false
  }))
);

export const getLegalEntitiesHierarchy = (state: LegalEntitiesHierarchyState) => {
  let newArr;
  let parse;

  if (state.loadLegalEntitiesHierarchyResponse !== undefined) {
    const stringify = JSON.stringify(state.loadLegalEntitiesHierarchyResponse);
    parse = JSON.parse(stringify);

    // Handle orphaned nodes - nodes with parentLegalEntityId that don't exist in the dataset
    if (parse && Array.isArray(parse)) {
      const existingIds = new Set(parse.map(item => item.legalEntityId));

      // Find orphaned nodes and convert them to root nodes
      const processedData = parse.map(item => {
        if (item.parentLegalEntityId && !existingIds.has(item.parentLegalEntityId)) {
          // This is an orphaned node - make it a root node by removing parentLegalEntityId
          return {
            ...item,
            parentLegalEntityId: null
          };
        }
        return item;
      });

      return processedData;
    }

    return parse;
  }
};

export const getLegalEntitiesHierarchyIsLoaded = (state: LegalEntitiesHierarchyState) => state.loaded;

export const getSavedLegalEntityId = (state: LegalEntitiesHierarchyState) => state.saveLegalEntityId;
